import { API_ADMIN_URL } from "../../../config/constants";
import { postRequest, getRequest } from "../../API";

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : detailsList
* Description   : Get details list of all campaign
* By            : Afsar Ali
* Date          : 10-01-2026 
*********************************************************/
export const detailsList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/details-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : changeStatus
* Description   : change status
* By            : Md Rashd Ali
* Date          : 18-12-2024 
*********************************************************/
export const changeStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Md Rashid Ali
* Date          : 11-12-2024 
*********************************************************/
export const addeditdata = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/addeditdata`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            console.log('res',res);
            return {status : false, message:res?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Md Rashid Ali
* Date          : 11-12-2024 
*********************************************************/
export const drawDateTime = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/change-draw-date`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Md Rashid Ali
* Date          : 11-12-2024 
*********************************************************/
export const addeditprize = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/addeditprize`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const prizeList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/prize-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Md Rashid Ali
* Date          : 11-12-2024 
*********************************************************/
export const addeditSetting = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/addeditsettings`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const settingList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/setting-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const orderList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/order-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {
                status : true,
                result : res?.data?.response?.result,
                count : res?.data?.response?.count,
                nextCursor : res?.data?.response?.nextCursor,
            };
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : changeStatus
* Description   : change status
* By            : Md Rashd Ali
* Date          : 18-12-2024 
*********************************************************/
export const changeOrderStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/cancel-order`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addeditdatafreezes
* Description   : change service status
* By            : Md Rashid Ali
* Date          : 11-12-2024 
*********************************************************/
export const addeditdatafreezes = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/campaign-freezes-data`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const freezesList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/campaign-freezes-data`,
            postData : options
        }
        const res = await getRequest(params);
        if(res){
            return {status : true, result : res};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : reverseOrderCancel
* Description   : reverse Cancellled Order 
* By            : Sumit Bedwal
* Date          : 06-02-2026 
*********************************************************/
export const reverseOrderCancel = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/reverse-cancelled-order`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function